export default "__VITE_ASSET__CFgnfCz5__"